import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";

const formatValue = (value, noDecimals = false) => {
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    if (noDecimals) return Math.round(num).toString();
    return num.toFixed(2);
};

function RecordsCard({ title, rows = [], noDecimals = false }) {
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <article className="bg-[#102216] rounded-xl border border-white/10 overflow-hidden shadow-sm transition-all duration-300 hover:border-green-500/40 hover:bg-[#152b1d]">
            <button
                type="button"
                onClick={() => setIsExpanded((prev) => !prev)}
                className="w-full px-5 py-4 border-b border-white/10 flex items-center justify-between bg-white/5 hover:bg-white/10 transition-colors"
                aria-expanded={isExpanded}
            >
                <span className="w-5" aria-hidden="true"></span>
                <h3 className="text-sm font-bold text-green-500 uppercase tracking-wider text-center flex-1">{title}</h3>
                <span
                    className={`w-5 text-slate-300 text-base transition-transform duration-200 ${isExpanded ? "rotate-180" : "rotate-0"}`}
                    aria-hidden="true"
                >
                    ˅
                </span>
            </button>

            <AnimatePresence initial={false}>
            {isExpanded ? (
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.25, ease: "easeInOut" }}
                    className="overflow-hidden"
                >
                <div className="p-3 space-y-1">
                {rows.length ? rows.map((row) => (
                    <div
                        key={row.id}
                        className="flex items-center justify-between p-3 rounded-lg hover:bg-black/20 transition-colors group"
                    >
                        <div className="flex items-start gap-4 min-w-0">
                            <span className={`text-xs font-bold w-4 ${row.rank === 1 ? "text-green-500" : "text-slate-500"}`}>
                                {row.rank}
                            </span>
                            <div className="min-w-0">
                                <Link
                                    to={`/jugador/${encodeURIComponent(row.slug || row.name)}`}
                                    className="text-sm font-semibold text-slate-100 group-hover:text-green-500 transition-colors truncate block"
                                >
                                    {row.name}
                                </Link>
                                {row.description ? (
                                    <p className="text-xs text-slate-500 truncate mt-0.5">{row.description}</p>
                                ) : null}
                            </div>
                        </div>
                        <span className={`text-base font-black tabular-nums ${row.rank === 1 ? "text-white" : "text-slate-300"}`}>
                            {formatValue(row.value, noDecimals)}
                        </span>
                    </div>
                )) : (
                    <p className="px-3 py-4 text-sm text-slate-400">Sin datos disponibles.</p>
                )}
                </div>
                </motion.div>
            ) : null}
            </AnimatePresence>
        </article>
    );
}

export default RecordsCard;
